<template>
  <div class="k-bignumbers-repeater">
    <draggable
      :list="items"
      group="fields"
      animation="150"
      handle=".drag-handle"
      class="drag-app-widgets-items"
      @end="$emit('update:modelValue', items)"
    >
      <div v-for="(item, index) in items" :key="index" class="k-bignumbers-repeater-item">
        <v-row dense>
          <v-col cols="6">
            <v-btn
              class="drag-handle"
              color="var(--primary)"
              density="compact"
              variant="text"
              size="small"
            >
              <i class="fal fa-ellipsis-v"></i>
            </v-btn>
            <small>Item {{ index + 1 }} </small></v-col
          >
          <v-col cols="6" class="ml-auto text-right">
            <v-btn
              color="var(--danger)"
              variant="text"
              size="x-small"
              icon
              class="btn btn-sm"
              @click="removeRow(index)"
            >
              <i class="fal fa-times"></i>
            </v-btn>
          </v-col>
        </v-row>
        <k-field-group :name="$t('title')" labelsize="4">
          <tip-tap-input
            v-model="item.name"
            @update:modelValue="update"
            :fields="fields"
          />
        </k-field-group>
        <k-field-group :name="$t('value')" labelsize="4">
          <tip-tap-input
            v-model="item.value"
            @update:modelValue="update"
            :fields="fields"
          />
        </k-field-group>
        <k-field-group :name="$t('description')" labelsize="4">
          <tip-tap-input
            v-model="item.description"
            @update:modelValue="update"
            :fields="fields"
          />
        </k-field-group>
      </div>
    </draggable>

    <div class="text-right">
      <v-btn
        @click="addItem"
        class="btn btn-sm px-1 ml-auto text-right"
        color="var(--primary)"
        density="compact"
        variant="text"
        size="x-small"
      >
        <i class="fal fa-plus mr-2"></i> {{ $t("add") }}
      </v-btn>
    </div>
  </div>
</template>

<script>
  import TipTapInput from "@/components/TipTapInput.vue";
  import { VueDraggableNext } from "vue-draggable-next";
  export default {
    name: "KBignumberRepeater",
    props: {
      modelValue: {
        type: Array,
        default: () => [],
      },
      fields: {
        type: Array,
        default: () => [],
      },
    },

    components: {
      TipTapInput,
      draggable: VueDraggableNext,
    },
    data() {
      return {};
    },
    computed: {
      items: {
        get() {
          return this.modelValue;
        },
        set(newItems) {
          console.log("newItems", newItems);
          this.$emit("update:modelValue", newItems);
        },
      },
    },
    methods: {
      addItem() {
        const newItems = [...this.items];
        newItems.push({
          name: ``,
          value: null,
          type: "",
        });
        this.items = newItems;
      },

      update() {
        this.$emit("update:modelValue", this.items);
      },
      removeRow(index) {
        this.items.splice(index, 1);
        this.$emit("update:modelValue", this.items);
      },
    },
  };
</script>

<style>
  .k-bignumbers-repeater {
    display: block;
    width: 100%;

    .k-bignumbers-repeater-item {
      width: 100%;
      gap: 4px;
      margin-bottom: 5px;
      position: relative;
      background: #fafafb;
      padding: 5px;
      border-radius: 8px;
      width: 100%;

      .drag-handle {
        padding: 0px;
        min-width: 0px !important;
        width: 10px !important;
        height: 100% !important;

        .v-btn__content {
          font-size: 20px;
        }
      }

      .input-col {
        width: 60%;
      }

      .tiptap-col {
        width: 54%;
      }

      .btn-col {
        width: 6%;
      }
    }
  }
</style>
